import React from 'react'
import { Input } from 'antd'

import styles from "./styles.module.scss"
import clsx from 'clsx'

export default function CustomPartialPayment({ onClick, selected, customAmount, setCustomAmount }) {
    return (
        <div className={styles.customPartialPaymentContainer}>
            <span className={styles.customPartialPaymentLabel}>Custom Amount</span>
            <div className={styles.customPartialPaymentRow}>
                <div className={clsx([styles.customPartialPaymentButton, selected && styles.active])}
                    onClick={onClick}
                >Custom</div>
                <Input prefix="$"
                    disabled={!selected}
                    defaultValue={0}
                    className={styles.customPartialPaymentInput}
                    value={customAmount}
                    type='number'
                    onChange={(e) => {
                        setCustomAmount(e.target.value)
                        // console.log('e.target.value', e.target.value)
                        // if (Number(e.target.value) >= 0)
                        //     setCustomAmount(Number(e.target.value) ?? 0)
                    }}
                    min={0}
                />
            </div>
        </div>
    )
}
